module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapterno"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('b', [_vm._v("1")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "chapter"
  }, [_vm._v("VALUE YOUR TIME")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The other day subscriber WK sent me an e-mail asking if we could have lunch:")]), _vm._v(" "), _c('p', {
    staticClass: "block_ind"
  }, [_vm._v("“I’d like a chance to meet you, if possible, just to meet so that sometime in the future we might be able to work on something together,” wrote WK. “I live in northern NJ so we aren’t so far apart. I’ve probably been in your neighborhood many times.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I get asked to lunch by subscribers who live in or near my area a few times a month. And I always say no.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here’s why I won’t go to lunch with WK or even you, as much as I may like you:")])]), _c('p', {
    staticClass: "listt"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("1.   I find going out to lunch in the middle of a work day to be an enormous drain on my severely limited supply of time. I would rather spend the time working.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "list"
  }, [_vm._v("2.   Many subscribers try to tempt me by saying the lunch will be on them.")]), _vm._v(" "), _c('p', {
    staticClass: "list_para"
  }, [_vm._v("I charge hundreds of dollars an hour for my time. Do you think paying $10 for my tuna sandwich and Diet Coke is really a tempting bribe for me?")]), _vm._v(" "), _c('p', {
    staticClass: "list_para"
  }, [_vm._v("Some people up the ante by offering to take me to an expensive restaurant. This plea falls on deaf ears; I don’t care that much what I eat and fancy restaurants don’t appeal to me. And if I desire an expensive meal I can well afford to pay for it myself.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("3.   I am introverted and even reclusive by nature. I have no desire to eat lunch with someone I don’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("4.   WK says we should meet “so that sometime in the future we might be able to work on something together.”")]), _vm._v(" "), _c('p', {
    staticClass: "list_para"
  }, [_vm._v("If WK or anyone else wants to work with me, we do not need to meet to make that happen.")]), _vm._v(" "), _c('p', {
    staticClass: "list_para"
  }, [_vm._v("I virtually never go to meetings; all my work is done via FedEx, fax, mail, and e-mail.")]), _vm._v(" "), _c('p', {
    staticClass: "list_para"
  }, [_vm._v("I rarely leave my desk during the day. And I almost never travel, except for seminars.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("5.   Should WK want to ask me for advice, he can do so by e-mail or phone, and I will gladly answer short questions at no charge.")]), _vm._v(" "), _c('p', {
    staticClass: "list_para"
  }, [_vm._v("A question I could answer in 2 minutes on the phone or by e-mail would take up an hour or two of my time at lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The fact is there are very few things in my life I value as much as my time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not money. Money can be replaced. If you lose money, you can always make more of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But time is irreplaceable. Once it’s gone, it’s gone for good. You can never get it back.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("If I spend 2 hours having lunch with WK, that’s 2 hours away from doing my client work … or writing my book … or spending time with my family … or doing other things I like to do.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This is why I have never been big on joining committees for clubs, business associations, and the like — they suck up precious time that could be used for more rewarding or pleasurable activities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the best ways to not squander your precious, limited time is to learn to say “no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I can’t have lunch with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I can’t attend that meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I can’t serve on that committee.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I can’t volunteer to serve in that capacity.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My attitude may raise your hackles or offend your sensibilities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That is not my intention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am not telling you what to do or how to live your life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But people ask me how I am able to get so much done in my life — a continual stream of copywriting projects, these 2X weekly e-mail articles, columns, seminars, information products, 80 published books and counting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is by valuing, conserving, and protecting my time like it was gold in Fort Knox — and learning the magic of saying “no.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63945da2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/10_ch1.vue
// module id = 84
// module chunks = 0